export default __webpack_public_path__ + "static/media/IBMFolderShared.fa754024.svg";